module.exports = __webpack_public_path__ + "static/scale-model-of-walk-sf-tours-in-berkeley-california-f68f9ee11c7414af0b194339a6e6d1e3.png";